<template>
  <div>
    <div class="d-flex flex-row">
      <p class="subtitle-2 font-weight-bold mb-4">Paid Payments</p>
      <div v-if="!mobile" class="flex-grow-1"></div>
      <div v-if="showBatchActions">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mx-1"
              small
              depressed
              color="white"
              :disabled="!approveActivateCondition"
              v-on="on"
              @click="batchApprovePaidPayments"
              >Approve
            </v-btn>
          </template>
          <p class="white--text">
            Approve multiple paid payments that are in pending approval state.
          </p>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mx-1"
              small
              depressed
              color="white"
              :disabled="!approveActivateCondition"
              v-on="on"
              @click="batchRejectPaidPayments"
              >Reject
            </v-btn>
          </template>
          <p class="white--text">
            Reject multiple paid payments that are in pending approval state.
          </p>
        </v-tooltip>
        <v-btn
          class="mx-1"
          small
          depressed
          color="white"
          :disabled="!voidAndCancelActivateCondition"
          @click="batchVoidPaidPayments"
          >Void</v-btn
        >
        <v-btn
          class="mx-1"
          small
          depressed
          color="white"
          :disabled="!voidAndCancelActivateCondition"
          @click="batchCancelPaidPayments"
          >Cancel</v-btn
        >
      </div>
      <dots-menu :menu-items="menuItems"></dots-menu>
    </div>
    <v-card
      v-if="paymentAccess.read"
      v-show="!loading"
      elevation="0"
      class="card-container px-8 py-4"
    >
      <div v-if="!mobile">
        <v-data-table
          v-model="selected"
          class="denser"
          :headers="headers"
          :items="paidPayments"
          :options.sync="options"
          :server-items-length="total"
          item-key="refNo"
          :loading="loading"
          loading-text="Loading... Please wait"
          no-data-text="All Paid Payments will appear here."
          multi-sort
          :footer-props="{ 'items-per-page-options': [12, 24, 48, 96, 200] }"
          :show-select="showBatchActions"
          dense
        >
          <template v-slot:expanded-item="{ item }">
            <tr
              v-for="(paymentDetailItem, expandIndex) in item.payment_details"
              :key="`expand_${paymentDetailItem.refNo}_${generateId()}`"
              :class="expandedItemRow(expandIndex, item.payment_details)"
              @click="showPayment(paymentDetailItem)"
            >
              <td></td>
              <td>
                <p class="caption">{{ paymentDetailItem.refNo }}</p>
              </td>
              <td>
                <p class="caption">{{ paymentDetailItem.date }}</p>
              </td>
              <td v-if="type !== Types.UNIT" class="text-overflow">
                <a class="caption" @click="redirectBed(item)">{{
                  item.unitName
                }}</a>
              </td>
              <td
                v-if="type !== Types.UNIT && type !== Types.USER"
                class="text-overflow"
              >
                <p class="caption">{{ item.tenantName }}</p>
              </td>
              <!-- <td class="text-overflow"><p class="caption">{{item.tenantName}}</p></td> -->
              <td>
                <p class="caption">{{ paymentDetailItem.category }}</p>
              </td>
              <td>
                <p class="caption">{{ paymentDetailItem.period }}</p>
              </td>
              <td>
                <p class="caption">
                  {{ formatCurrency(paymentDetailItem.total) }}
                </p>
              </td>
              <td>
                <p class="caption">
                  {{
                    formatCurrency(
                      paymentDetailItemAmountPaid(
                        paymentDetailItem,
                        item.paidPaymentId
                      )
                    )
                  }}
                </p>
              </td>
              <td>
                <p :class="statusClass(paymentDetailItem.raw_status)">
                  {{ paymentDetailItem.status }}
                </p>
              </td>
              <td>
                <div class="d-flex flex-row">
                  <v-tooltip
                    v-if="
                      paymentDetailItem.status &&
                      (paymentDetailItem.raw_status === PaymentStatus.PENDING ||
                        paymentDetailItem.raw_status ===
                          PaymentStatus.PAID_PARTIAL) &&
                      paidpaymentAccess.create
                    "
                    bottom
                    dark
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        color="primary"
                        x-small
                        :disabled="!paidpaymentAccess.create"
                        @click.stop="setPaid(paymentDetailItem)"
                        v-on="on"
                      >
                        <v-icon>mdi-check-decagram</v-icon>
                      </v-btn>
                    </template>
                    <span style="color: white">Payment Received</span>
                  </v-tooltip>
                </div>
              </td>
            </tr>
          </template>
          <template
            v-slot:item="{
              expand,
              item,
              isExpanded,
              index,
              isSelected,
              select
            }"
          >
            <tr
              v-if="!isNaN(item.paidPaymentId)"
              :key="index"
              v-long-press="(e) => onRowLongPress(item, e)"
              :class="paidItemRow(isExpanded)"
              @click="showPaidPayment(item)"
              @contextmenu.prevent="showActions(item, $event)"
            >
              <td v-if="showBatchActions">
                <v-checkbox
                  v-model="isSelected"
                  hide-details
                  dense
                  class="mt-0"
                  @change="select"
                  @click.stop
                ></v-checkbox>
              </td>
              <td v-else>
                <v-btn
                  v-if="!isExpanded"
                  icon
                  x-small
                  @click.stop="expand(true)"
                  ><v-icon small>mdi-chevron-down</v-icon></v-btn
                >
                <v-btn
                  v-if="isExpanded"
                  icon
                  x-small
                  @click.stop="expand(false)"
                  ><v-icon small>mdi-chevron-up</v-icon></v-btn
                >
              </td>
              <td>
                <p class="caption">{{ item.refNo }}</p>
              </td>
              <td>
                <p class="caption">{{ item.date }}</p>
              </td>
              <td v-if="type !== Types.UNIT" class="text-overflow">
                <a class="caption" @click="redirectBed(item)">{{
                  item.unitName
                }}</a>
              </td>
              <td
                v-if="type !== Types.UNIT && type !== Types.USER"
                class="text-overflow"
              >
                <a
                  v-if="!item.unitName"
                  class="caption"
                  @click="redirectBed(item)"
                  >{{ item.tenantName }}</a
                >
                <p v-else class="caption">{{ item.tenantName }}</p>
              </td>
              <td>
                <p class="caption">{{ item.category }}</p>
              </td>
              <td>
                <p class="caption">{{ item.period }}</p>
              </td>
              <td>
                <p class="caption">{{ formatCurrency(item.total) }}</p>
              </td>
              <td>
                <p class="caption">{{ formatCurrency(item.amount) }}</p>
              </td>
              <td>
                <div class="d-flex flex-row">
                  <p :class="statusClass(item.raw_status)">
                    {{ item.status }}
                  </p>
                  <v-tooltip v-if="hasPartialPayments(item)" bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon class="ml-1" color="warning" x-small v-on="on"
                        >mdi-alert-circle-check</v-icon
                      >
                    </template>
                    <p class="white--text">Contains unpaid partial payments</p>
                  </v-tooltip>
                  <v-tooltip v-if="item.total < item.amount" bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon class="ml-1" color="success" x-small v-on="on"
                        >mdi-arrow-up-bold-circle-outline</v-icon
                      >
                    </template>
                    <p class="white--text">Overpayment</p>
                  </v-tooltip>
                </div>
              </td>
            </tr>
            <tr v-else style="cursor: pointer" @click="showPayment(item)">
              <td></td>
              <td>
                <p class="caption">{{ item.refNo }}</p>
              </td>
              <td>
                <p class="caption">{{ item.date }}</p>
              </td>
              <td v-if="type !== Types.UNIT" class="text-overflow">
                <a class="caption" @click="redirectBed(item)">{{
                  item.unitName
                }}</a>
              </td>
              <td
                v-if="type !== Types.UNIT && type !== Types.USER"
                class="text-overflow"
              >
                <a class="caption" @click="redirectBed(item)">{{
                  item.tenantName
                }}</a>
              </td>
              <td>
                <p class="caption">{{ item.category }}</p>
              </td>
              <td>
                <p class="caption">{{ item.period }}</p>
              </td>
              <td>
                <p class="caption">{{ formatCurrency(item.total) }}</p>
              </td>
              <td>
                <p class="caption">{{ formatCurrency(item.amountPaid) }}</p>
              </td>
              <td>
                <p :class="statusClass(item.raw_status)">{{ item.status }}</p>
              </td>
              <td>
                <div v-if="item.raw_status">
                  <div
                    v-if="item.raw_status !== PaymentStatus.PENDING_APPROVAL"
                    class="d-flex flex-row"
                  >
                    <!-- TODO: refactor all the other actions to use action-button -->
                    <action-button
                      :activate-condition="
                        (item.raw_status === PaymentStatus.PENDING ||
                          item.raw_status === PaymentStatus.PAID_PARTIAL) &&
                        paidpaymentAccess.create
                      "
                      :disabled-condition="!paidpaymentAccess.create"
                      title="Payment Received"
                      :action="() => setPaid(item)"
                      icon="mdi-check-decagram"
                      color="primary"
                    ></action-button>
                    <action-button
                      :activate-condition="
                        item.raw_status === PaymentStatus.PENDING &&
                        paymentrequestAccess.update
                      "
                      :disabled-condition="
                        !paymentrequestAccess.update || item.readonly
                      "
                      title="Update Payment"
                      :action="() => updatePayment(item)"
                      icon="mdi-pencil"
                      color="primary"
                    ></action-button>
                    <action-button
                      :activate-condition="
                        item.raw_status != PaymentStatus.VOID &&
                        item.raw_status != PaymentStatus.VOID_CREDIT_BALANCE &&
                        item.raw_status != PaymentStatus.CANCELED &&
                        paymentrequestAccess.void
                      "
                      :disabled-condition="
                        !paymentrequestAccess.void || item.readonly
                      "
                      title="Void Payment"
                      :action="() => voidPayment(item)"
                      icon="mdi-cash-remove"
                    ></action-button>
                    <action-button
                      :activate-condition="
                        item.raw_status != PaymentStatus.VOID &&
                        item.raw_status != PaymentStatus.VOID_CREDIT_BALANCE &&
                        item.raw_status != PaymentStatus.CANCELED &&
                        paymentrequestAccess.void
                      "
                      :disabled-condition="
                        !paymentrequestAccess.cancel || item.readonly
                      "
                      title="Cancel Payment"
                      :action="() => cancelPayment(item)"
                      icon="mdi-close"
                      color="red"
                    ></action-button>
                  </div>
                  <div v-else class="d-flex flex-row">
                    <action-button
                      :activate-condition="true"
                      :disabled-condition="
                        !paymentrequestAccess.approve || item.readonly
                      "
                      title="Approve payment request"
                      :action="() => approvePaymentRequest(item)"
                      icon="mdi-check"
                      color="primary"
                    ></action-button>
                    <action-button
                      :activate-condition="true"
                      :disabled-condition="
                        !paymentrequestAccess.reject || item.readonly
                      "
                      title="Reject payment request"
                      :action="() => rejectPaymentRequest(item)"
                      icon="mdi-cancel"
                      color="error"
                    ></action-button>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <v-skeleton-loader
      v-show="loading"
      ref="skeleton"
      type="table"
      loading
      class="mx-auto"
    ></v-skeleton-loader>
    <Invoice ref="invoice"></Invoice>
    <ConfirmPayment ref="confirmPayment"></ConfirmPayment>
    <VoidPayment ref="voidPayment"></VoidPayment>
    <VoidPaidPayment ref="voidPaidPayment"></VoidPaidPayment>
    <CancelPayment ref="cancelPayment"></CancelPayment>
    <CancelPaidPayment ref="cancelPaidPayment"></CancelPaidPayment>
    <GenerateReport ref="generateReport"></GenerateReport>
    <CreateMultiplePayments
      ref="createMultiplePayments"
    ></CreateMultiplePayments>
    <UpdatePaymentRequest ref="updatePaymentRequest"></UpdatePaymentRequest>
    <ApprovePaymentRequest ref="approvePaymentRequest"></ApprovePaymentRequest>
    <ApprovePaidPayment ref="approvePaidPayment"></ApprovePaidPayment>
    <paid-payment-invoice ref="paidPaymentInvoice"></paid-payment-invoice>
    <update-paid-payment ref="updatePaidPayment"></update-paid-payment>
    <context-menu
      ref="contextMenu"
      no-items-message="No actions available"
    ></context-menu>
    <batch-approve-paid-payments
      ref="batchApprovePaidPayments"
    ></batch-approve-paid-payments>
    <batch-reject-paid-payments
      ref="batchRejectPaidPayments"
    ></batch-reject-paid-payments>
    <generate-paid-payment-report
      ref="generatePaidPaymentReport"
    ></generate-paid-payment-report>
    <batch-cancel-paid-payments ref="batchCancelPaidPayments">
    </batch-cancel-paid-payments>
    <batch-void-paid-payments ref="batchVoidPaidPayments">
    </batch-void-paid-payments>
  </div>
</template>

<script>
import Invoice from '../../components/Invoice.vue'
import ConfirmPayment from '../../components/payment/ConfirmPayment.vue'
import VoidPayment from '../../components/payment/VoidPayment.vue'
import VoidPaidPayment from '../../components/payment/VoidPaidPayment.vue'
import CancelPayment from '../../components/payment/CancelPayment.vue'
import CancelPaidPayment from '../../components/payment/CancelPaidPayment.vue'
import GenerateReport from '../../components/payment/GenerateReport.vue'
import CreateMultiplePayments from '../../components/payment/CreateMultiplePayments.vue'
import UpdatePaymentRequest from '../../components/units/UpdatePaymentRequest.vue'
import ApprovePaymentRequest from '../../components/payment/ApprovePaymentRequest.vue'
import ApprovePaidPayment from '../../components/payment/ApprovePaidPayment.vue'
import ActionButton from '../../components/ActionButton.vue'
import PaidPaymentInvoice from '../../components/payment/PaidPaymentInvoice.vue'
import UpdatePaidPayment from '../../components/payment/UpdatePaidPayment.vue'
import DotsMenu from '../../components/menu/DotsMenu.vue'
import ContextMenu from '../../components/menu/ContextMenu.vue'
import BatchApprovePaidPayments from '../../components/payment/BatchApprovePaidPayments.vue'
import BatchRejectPaidPayments from '../../components/payment/BatchRejectPaidPayments.vue'
import GeneratePaidPaymentReport from '../../components/payment/GeneratePaidPaymentReport.vue'
import BatchCancelPaidPayments from '../../components/payment/BatchCancelPaidPayments.vue'
import BatchVoidPaidPayments from '../../components/payment/BatchVoidPaidPayments.vue'

import Hashids from 'hashids'
import { nanoid } from 'nanoid/non-secure'
import {
  paymentStatusSelect,
  PaymentStatus,
  PaymentCategories,
  PaidPaymentStatus
} from '../../config/payment'
import { blockClick } from '../../util/longPressDirective'
const hashids = new Hashids()

export default {
  components: {
    Invoice,
    ConfirmPayment,
    VoidPayment,
    CancelPayment,
    CancelPaidPayment,
    GenerateReport,
    CreateMultiplePayments,
    UpdatePaymentRequest,
    VoidPaidPayment,
    ApprovePaymentRequest,
    ApprovePaidPayment,
    ActionButton,
    PaidPaymentInvoice,
    UpdatePaidPayment,
    ContextMenu,
    DotsMenu,
    BatchApprovePaidPayments,
    BatchRejectPaidPayments,
    GeneratePaidPaymentReport,
    BatchCancelPaidPayments,
    BatchVoidPaidPayments
  },
  props: [
    'searchString',
    'selectedTags',
    'selectedCategories',
    'selectedStatuses',
    'reloadTrigger',
    'tenantId',
    'type'
  ],
  data() {
    return {
      loading: true,
      limit: 0,
      total: 0,
      options: {},
      dialog: false,
      item: {},
      pageCount: 0,
      propertyTags: [],
      statusItems: paymentStatusSelect,
      categories: [],
      progressMsg: '',
      expandedPayments: [],
      allExpanded: false,
      togglePaymentMobileIcon: 'mdi-chevron-down',
      PaymentStatus,
      PaymentCategories,
      PaidPaymentStatus,
      Types: {
        UNIT: 'unit',
        USER: 'user'
      },
      showBatchActions: false,
      selected: []
    }
  },
  computed: {
    paidPayments() {
      return this.$store.getters['payments/getPaidPayments']
    },
    headers() {
      const headers = this.$store.getters['payments/getPaidPaymentHeaders']

      switch (this.type) {
        case this.Types.UNIT:
          return headers.filter(
            (h) => !['unitName', 'tenantName'].includes(h.value)
          )
        case this.Types.USER:
          return headers.filter((h) => !['tenantName'].includes(h.value))
        default:
          return headers
      }
    },
    property() {
      return this.$store.getters['properties/getProperty']
    },
    user() {
      return this.$store.getters['auth/getUser']
    },
    paymentAccess() {
      return this.$root.$roleAccess('payment').access
    },
    paymentrequestAccess() {
      return this.$root.$roleAccess('paymentrequest').access
    },
    paidpaymentAccess() {
      return this.$root.$roleAccess('paidpayment').access
    },
    mobile() {
      return this.$vuetify.breakpoint.xs
    },
    menuItems() {
      return [
        {
          icon: 'mdi-pencil',
          title: 'Toggle batch actions',
          action: this.toggleBatchActions,
          disabled: null,
          message: 'Batch actions on paid payments'
        },
        {
          icon: 'mdi-file-table',
          title: 'Generate Paid Payments Report',
          action: this.openGenerateReportDialog,
          disabled: !this.paymentAccess.report,
          message: 'Download the transactions as an Excel-compatible CSV file'
        }
      ]
    },
    approveActivateCondition() {
      return (
        this.selected.length > 0 &&
        this.selected.every(
          (item) => item.raw_status === PaidPaymentStatus.PENDING_APPROVAL
        )
      )
    },
    voidAndCancelActivateCondition() {
      return (
        this.selected.length > 0 &&
        this.selected.every(
          (item) => item.raw_status === PaidPaymentStatus.PAID
        )
      )
    }
  },
  watch: {
    options: {
      async handler() {
        await this.reload()
      }
    },
    reloadTrigger: {
      async handler() {
        await this.reload()
      }
    }
  },
  methods: {
    reloadFromAction() {
      this.$emit('reload')
      this.reload()
    },
    async reload() {
      this.loading = true
      const response = await this.$store.dispatch(
        'payments/fetchPaidPaymentsAction',
        {
          page: this.options.page,
          limit: this.options.itemsPerPage,
          sortBy: this.options.sortBy,
          sortDesc: this.options.sortDesc,
          search: this.searchString,
          status: this.selectedStatuses || [],
          categories: this.selectedCategories,
          tags: this.selectedTags,
          tenantId: this.tenantId
        }
      )

      this.loading = false
      this.limit = response.limit
      this.total = response.count
    },
    showPayment(item) {
      if (this.$refs.invoice) this.$refs.invoice.open({ item: item })
    },
    showPaidPayment(item) {
      if (this.$refs.paidPaymentInvoice)
        this.$refs.paidPaymentInvoice.open({ item })
    },
    async setPaid(item) {
      this.$refs.confirmPayment.open(item).then(() => {
        this.reloadFromAction()
      })
    },
    redirectBed(params) {
      const { bedId, username } = params
      // this.$router.push(`/user/${tenant.username}`)
      if (bedId != null) this.$router.push(`/bed/${hashids.encode(bedId)}`)
      else this.$router.push(`/user/${username}`)
    },
    voidPayment(item) {
      this.$refs.voidPayment.open(item).then(() => {
        this.reloadFromAction()
      })
    },
    cancelPayment(item) {
      this.$refs.cancelPayment.open(item).then(() => {
        this.reloadFromAction()
      })
    },
    formatCurrency(value) {
      if (value == null) return ''
      return parseFloat(value / 100).toLocaleString('en-PH', {
        style: 'currency',
        currency: 'PHP'
      })
    },
    async updatePayment(item) {
      this.$refs.updatePaymentRequest.open(item).then(async () => {
        this.loading = true
        await this.reloadFromAction()
      })
    },
    statusClass(status) {
      if (
        [PaymentStatus.PENDING, PaymentStatus.PENDING_APPROVAL].includes(status)
      ) {
        return 'red--text caption'
      } else {
        return 'caption'
      }
    },
    paidItemRow(isExpanded) {
      if (isExpanded) return 'row-item-expanded'
      else return
    },
    expandedItemRow(index, items) {
      // if(index === 0) return 'expand-item'
      if (index >= items.length - 1) return 'expand-item bottom-border'
      return 'expand-item'
    },
    cancelPaidPayment(item) {
      this.$refs.cancelPaidPayment.open(item).then(() => {
        this.reloadFromAction()
      })
    },
    voidPaidPayment(item) {
      this.$refs.voidPaidPayment.open(item).then(() => {
        this.reloadFromAction()
      })
    },
    paymentDetailItemAmountPaid(payment, paidPaymentId) {
      const items = payment.paidItems || []
      return (
        items
          .filter((item) => item.paidPaymentId === paidPaymentId)
          .reduce((a, b) => a + b.amount, 0) ||
        payment.amountPaid ||
        0
      )
    },
    togglePaymentMobile(payment) {
      if (this.expandedPayments.length > 0) {
        this.expandedPayments = []
        this.togglePaymentMobileIcon = 'mdi-chevron-down'
      } else {
        this.expandedPayments = [payment]
        this.togglePaymentMobileIcon = 'mdi-chevron-up'
      }
    },
    expandAll() {
      this.expandedPayments = this.payments
      this.allExpanded = true
    },
    collapseAll() {
      this.expandedPayments = []
      this.allExpanded = false
    },
    generateId() {
      return nanoid(5)
    },
    hasPartialPayments(item) {
      return item.payment_details.some((p) => p.status === 'Partial Payment')
    },
    approvePaymentRequest(payment) {
      this.$refs.approvePaymentRequest.open(payment).then(() => {
        this.reloadFromAction()
      })
    },
    rejectPaymentRequest(paymentId) {
      this.$root
        .$confirm({
          title: 'Reject payment request',
          message: 'Are you sure you want to reject the payment request?'
        })
        .then(async (confirm) => {
          if (confirm) {
            await this.$store.dispatch('payments/rejectPaymentRequestAction', {
              paymentId
            })
            await this.reloadFromAction()
          }
        })
    },
    approvePaidPayment(paidPayment) {
      this.$refs.approvePaidPayment.open(paidPayment).then(() => {
        this.reloadFromAction()
      })
    },
    rejectPaidPayment(paidPayment) {
      this.$root
        .$confirm({
          title: 'Reject payment',
          message: 'Are you sure you want to reject the payment?'
        })
        .then(async (confirm) => {
          if (confirm) {
            await this.$store.dispatch('payments/rejectPaidPaymentAction', {
              paidPaymentId: paidPayment.paidPaymentId
            })
            await this.reloadFromAction()
          }
        })
    },
    updatePaidPayment(paidPayment) {
      this.$refs.updatePaidPayment.open(paidPayment).then(() => {
        this.reloadFromAction()
      })
    },
    getBaseActions(item) {
      if (item.raw_status !== PaidPaymentStatus.PENDING_APPROVAL) {
        return [
          {
            icon: 'mdi-pencil',
            color: 'primary',
            title: 'Update Payment Details',
            action: () => this.updatePaidPayment(item),
            message: 'Update the details of the paid payment',
            show: this.paidpaymentAccess.update,
            disabled: !this.paidpaymentAccess.update
          },
          {
            icon: 'mdi-cash-remove',
            title: 'Void Payment',
            action: () => this.voidPaidPayment(item),
            message: 'Void the paid payment and revert the payment requests',
            show:
              item.raw_status != PaymentStatus.VOID &&
              item.raw_status != PaymentStatus.VOID_CREDIT_BALANCE &&
              item.raw_status != PaymentStatus.CANCELED &&
              this.paidpaymentAccess.void,
            disabled: !this.paidpaymentAccess.void
          },
          {
            icon: 'mdi-close',
            color: 'error',
            title: 'Cancel Payment',
            action: () => this.cancelPaidPayment(item),
            message: 'Cancel the payment and revert the payment requests',
            show:
              item.raw_status != PaymentStatus.VOID &&
              item.raw_status != PaymentStatus.VOID_CREDIT_BALANCE &&
              item.raw_status != PaymentStatus.CANCELED &&
              this.paidpaymentAccess.cancel,
            disabled: !this.paidpaymentAccess.cancel
          }
        ]
      } else {
        return [
          {
            icon: 'mdi-check',
            color: 'primary',
            title: 'Approve paid payment',
            action: () => this.approvePaidPayment(item),
            message: 'Approve receipt of payment from the tenant',
            show: true,
            disabled: !this.paidpaymentAccess.approve
          },
          {
            icon: 'mdi-cancel',
            color: 'error',
            title: 'Reject paid payment',
            action: () => this.rejectPaidPayment(item),
            message: 'Reject receipt of payment from the tenant',
            show: true,
            disabled: !this.paidpaymentAccess.reject
          }
        ]
      }
    },
    showActions(item, event) {
      const actions = this.getBaseActions(item)

      this.$refs.contextMenu.open({
        actions,
        x: event.clientX,
        y: event.clientY
      })

      this.$nextTick(() => {
        this.showContextMenu = true
      })
    },
    toggleBatchActions() {
      // show checkboxes on the left
      // hide actions
      // show batch action buttons
      this.showBatchActions = !this.showBatchActions
    },
    batchApprovePaidPayments() {
      this.$refs.batchApprovePaidPayments
        .open({ payments: this.selected })
        .then(() => {
          this.reloadFromAction()
          this.resetSelected()
        })
    },
    batchRejectPaidPayments() {
      this.$refs.batchRejectPaidPayments
        .open({ payments: this.selected })
        .then(() => {
          this.reloadFromAction()
          this.resetSelected()
        })
    },
    openGenerateReportDialog() {
      this.$refs.generatePaidPaymentReport.open()
    },
    batchCancelPaidPayments() {
      this.$refs.batchCancelPaidPayments
        .open({ payments: this.selected })
        .then(() => {
          this.reloadFromAction()
          this.resetSelected()
        })
    },
    batchVoidPaidPayments() {
      this.$refs.batchVoidPaidPayments
        .open({ payments: this.selected })
        .then(() => {
          this.reloadFromAction()
          this.resetSelected()
        })
    },
    resetSelected() {
      this.selected = []
    },
    onRowLongPress(item, event) {
      this.showActions(item, event)
      blockClick(window)
    }
  }
}
</script>

<style scoped>
table thead tr th {
  white-space: nowrap !important;
}
.card-container {
  border-radius: 12px !important;
}
.v-input {
  border-radius: 10px;
}
table tbody tr td {
  /*border: none !important;
    border-bottom: none !important;*/
  border-color: #eeeeee !important;
}
p {
  margin-bottom: 0;
}
.text-overflow {
  max-width: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.row-item-expanded td p {
  font-weight: bold;
}
.row-item-expanded td {
  border: none !important;
}
.expand-item td p {
  font-weight: 300;
  font-size: 11px !important;
}
.expand-item td {
  border: none !important;
}
tr.bottom-border td {
  /*border-bottom: thin solid #CCC !important;*/
  border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}
.table-footer-prepend {
  margin-top: -54px;
  height: 48px;
}
.test {
  border: 2px solid yellow;
}
</style>
